import React from 'react';
import { motion } from 'framer-motion';
export const PromoStrip = () => {
  return;
};